<template>
  <BaseModal class="client-modal-wrapper" @backdropClick="close" :containerWidth="'90vw'">
    <div class="client-modal-container">
      <div class="client-card-row">
        <div class="client-details">
          <div class="card-param">
            <span class="card-param-type">
              {{ $t('client_card.phone') }}
            </span>
            {{ client.phone }}
          </div>
          <div class="card-param">
            <span class="card-param-type">
              {{ $t('client_card.address') }}
            </span>
            {{ client.address }}
          </div>
          <div class="card-param">
            <span class="card-param-type">
              {{ $t('client_card.bonus_balance') }}
            </span>
            <span class="c-green"> {{balance.bonuses}} {{ currency.symbol }} </span>
          </div>
          <div class="card-param">
            <span class="card-param-type">
              {{ $t('client_card.average_check') }}
            </span>
            <span class="c-green">
              {{ client.average_check }} {{ currency.symbol }}
            </span>
          </div>
          <div class="card-param">
            <span class="card-param-type">
              {{ $t('client_card.total_orders') }}
            </span>
            <span class="c-green">
              {{ client.total_orders }}
            </span>
          </div>
        </div>
        <div class="client-avatar">
          <h2 class="client-name">{{ client.name }}</h2>
          <img src="/icons/client-avatar.svg" />
        </div>
      </div>

      <hr />
      <div class="checkbox-actions">
        <RoundCheckbox 
          :value="balance.collect_bonuses"
          @input="v => {
            balance.collect_bonuses = v; 
            updateBalance();
          }"
          class="pt-0 mt-0">
          {{ $t('client_card.option_bonuses') }}
        </RoundCheckbox>
        <div class="regular-sale-box mt-20">
          <RoundCheckbox 
          class="iqos-group-item" 
          :value="enable_discount"
          @input="toggleDiscount">
              {{ $t('client_card.option_discount') }}
          </RoundCheckbox>
          <BaseInput 
            :readonly="!enable_discount" 
            placeholder="0%" 
            v-model="balance.discount"
            @blur="updateBalance"
            class="w-200" />
        </div>
      </div>
      <hr />

      <table class="client-activity" v-if="orders.length">
        <thead>
          <tr>
            <th>{{ $t('client_card.table_date') }}</th>
            <th>{{ $t('client_card.table_time') }}</th>
            <th>{{ $t('client_card.table_discount') }}</th>
            <th>{{ $t('client_card.table_bonuses') }}</th>
            <th>{{ $t('client_card.table_price') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="info" v-for="order in orders" :key="order._id">
            <td>{{ order.created_at | formatDate}}</td>
            <td>{{ order.created_at | formatTime }}</td>
            <td>{{ order.discount || 0 }}%</td>
            <td>+{{currency.symbol}} {{ order.deposited_bonuses || 0 }}</td>
            <td>{{currency.symbol}} {{order.total}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/modals/BaseModal.vue";

import RoundCheckbox from "@/components/RoundCheckbox.vue";
import BlackInput from "@/components/BlackInput.vue";

import ClientsAPI from "@/api/clients";
import StatsAPI from '@/api/stats';

export default {
  props: {
    client: Object,
  },
  data() {
    return {
      orders: [],
      balance: {},

      enable_discount: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    fetchBalance() {
      ClientsAPI.getClientBalance(this.client._id, this.cafe._id)
        .then((data) => {
          this.balance = data.balance;

          if (this.balance.discount) {
            this.enable_discount = true;
          }
        })
        .catch((error) => {
          alert(error);
        });
    },
    toggleDiscount(v) {
      if (v) {
        this.enable_discount = true;
      } else {
        this.enable_discount = false;
        this.balance.discount = 0;
        this.updateBalance();
      }
    },
    updateBalance() {
      ClientsAPI.updateClientBalance(this.balance._id, {
        discount: this.balance.discount,
        collect_bonuses: this.balance.collect_bonuses
      }).then(ok => {

      }).catch(error => {
        alert(error);
      })
    },
    fetchOrdersHistory() {
      StatsAPI.getClientOrdersHistory(
        this.cafe._id,
        this.client._id
      ).then(data => {
        this.orders = data.orders;
      }).catch(error => {
        alert(error);
      });
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    currency() {
      return this.$store.state.currency;
    },
  },
  mounted() {
    this.fetchBalance();
    this.fetchOrdersHistory();
  },
  components: {
    BaseModal,
    RoundCheckbox,
    BlackInput,
  },
};
</script>

<style scoped>
.mt-20 {
  margin-top: 2vh;
}

.w-200 {
  width: 22vh;
}

table.client-activity {
  width: 100%;
  position: relative;
  margin-top: 4.4vh;
  max-height: 36vh;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-flow: column;
  border-collapse: collapse;
}

table.client-activity thead {
  display: inline-table;
  width: 100%;
  position: sticky;
  top: -0.5vh;
  text-align: center;
  z-index: 1;
}

table.client-activity td,
table.client-activity th {
  background: #464646;
  font-size: 2.3vh;
  padding: 1vh 2vh;
  margin-top: 0.5vh;
  width: 12%;
  text-align: center;
}

table.client-activity th {
  color: #908f8d;
  position: sticky;
}

tr {
  position: relative;
  width: 100%;
  display: inline-table;
  margin-top: 0.3vh;
}



.regular-sale-box {
  display: flex;
  align-items: center;
}

.card-param {
  color: #ededed;
  font-size: 2.8vh;
}

.card-param:last-child {
  padding-bottom: 1.5vh;
}

.card-param-type {
  color: #908f8d;
}

.client-card-row {
  display: flex;
  justify-content: space-between;
}

.checkbox-actions {
  margin: 4.4vh 0;
  display: flex;
  flex-flow: column;
}

.client-modal-container {
  padding: 1.1vh;
}

.client-avatar {
  display: flex;
  align-content: center;
  align-items: center;
  /* margin-right: 3vh; */
  height: 11vh;
}

.client-avatar img {
  height: 100%;
  width: auto;
  display: block;
  position: relative;
}

.client-name {
  font-size: 4.4vh;
  margin-right: 1.65vh;
}
</style>